import React, { useState } from "react";
import { ModalConfirm } from "@talentbait/shared-components";
import logger from "../../../utils/LoggerFrontend";
import Actions from "../../../Actions";
import { getDefaultEndDate, isEndDateMoreThanTwoWeeks } from "./CampaignReadEditEndDate.service";
import moment from "moment";

function CampaignReadEditEndDate({
  campaignId,
  orgaId,
  currentEndDate,
  campaignDuration,
  campaignStatus,
  userName,
  i18n,
  onUpdate = () => {}
}) {
  logger.debug("CampaignReadEditEndDate", "CampaignReadEditEndDate called", {
    campaignId,
    campaignStatus,
    currentEndDate
  });

  const basedEndDate = getDefaultEndDate({ currentEndDate, campaignDuration });
  const [isUpdatingEndDate, setIsUpdatingEndDate] = useState(false);
  const [endDate, setEndDate] = useState(basedEndDate);

  const updateEndDate = () => {
    if (endDate === basedEndDate) {
      Actions.addNotification(i18n("Current end date is same as the new end date"), "error");
      return;
    }

    if (isEndDateMoreThanTwoWeeks(basedEndDate, endDate)) {
      Actions.addNotification(
        i18n(
          "End date cannot be more than 2 weeks from current end date, please contact your campaign manager"
        ),
        "error"
      );
      return;
    }

    setIsUpdatingEndDate(true);

    const ref = Actions.updateCampaignEndDate.completed.listen((data) => {
      logger.debug("CampaignReadEditEndDate:updateInvoicingDetails:completed", "called", {
        data,
        campaignId
      });
      setIsUpdatingEndDate(false);
      Actions.loadSingleCampaign(campaignId);
      Actions.addNotification(i18n("End date updated correctly"));
      Actions.toggleModal("showGenericModal", false);
      onUpdate();
      ref();
    });

    const refFailed = Actions.updateCampaignEndDate.failed.listen((error) => {
      logger.log("error:CampaignReadEditEndDate:updateInvoicingDetails", "failed", {
        error,
        campaignId
      });

      setIsUpdatingEndDate(false);

      Actions.addNotification(i18n("End date updated correctly"));
      Actions.toggleModal("showGenericModal", false);
      refFailed();
    });

    Actions.updateCampaignEndDate(campaignId, {
      endDate: new Date(endDate).toISOString(),
      orgaId,
      status: campaignStatus,
      userName
    });
  };

  const onChangeDate = (e) => {
    setEndDate(e.target.value);
  };

  return (
    <ModalConfirm
      style={{ padding: 15 }}
      showDescription={true}
      labelConfirm={isUpdatingEndDate ? "..." : "Aktualisieren"}
      cancelledAction={() => {
        Actions.toggleModal("showGenericModal", false);
      }}
      confirmedAction={updateEndDate}
      description={
        <div className="edit-date-popup-wrapper">
          <div className="grid__item">
            <span className="facebook__faded">{i18n("Custom End date (max 2 weeks)")}</span>
            <input
              className="pad-10 inp-admin"
              type="date"
              value={moment(endDate).format("YYYY-MM-DD")}
              onChange={onChangeDate}
              placeholder="Custom end date"
            />
          </div>
        </div>
      }
    />
  );
}

export default CampaignReadEditEndDate;
